/**
 * Banners Service for App-client
 * Fetches banner images for the carousel
 */

import { withApiErrorHandling, buildApiEndpoint } from '../utils/apiHelpers'
import apiClient from '../config/api'

/**
 * Fetch active banners for the carousel
 * @returns {Promise<Array>} Array of active banners sorted by display_order
 */
export const getActiveBanners = async () => {
  const endpoint = buildApiEndpoint('banners')

  return withApiErrorHandling(
    () => apiClient.get(endpoint, { params: { active_only: true } }),
    {
      defaultValue: [],
      transformData: (data) => data || [],
      logErrors: false
    }
  )
}

export const bannersService = {
  getActiveBanners,
}

export default bannersService
